/** 累计存款门槛（元）用于排序与比较 */
export function getTierThresholdYuan(t) {
  const n = Number(t?.threshold_yuan)
  return Number.isFinite(n) ? n : 0
}

export function sortPayinRebateTiersByThresholdAsc(tiers) {
  if (!Array.isArray(tiers)) return []
  return [...tiers].sort((a, b) => getTierThresholdYuan(a) - getTierThresholdYuan(b))
}

